(ns dre.pages.my-searches.signals.views
  (:require
   [dre.app.events :as app-events]
   [dre.app.router :as router :refer [->route]]
   [dre.components.icon :refer [fa-icon icon svg]]
   [dre.components.inputs :refer [input-search]]
   [dre.components.pill :as pill]
   [dre.components.table :refer [table]]
   [dre.modals.events :as-alias modals]
   [dre.pages.my-searches.signals.events :as-alias events]
   [dre.pages.my-searches.views :as my-searches]
   [dre.i18n.views :refer [tr]]
   [dre.i18n.events :as-alias i18n]
   [dre.utils :refer [roles-hash restricted-role?]]
   [dre.utils.bem :as bem]
   [dre.utils.query :as q]
   ["moment" :as moment]
   [re-frame.core :as rf]
   [reagent.core :as r]))

(def component-name :signals)

(defn signal-detail [signal r-hash ev]
  (doto ev .preventDefault .stopPropagation)
  (let [search-query (:query/search-query signal)
        search-query (assoc search-query :query/type (keyword (get search-query :query/type)))
        route (q/route search-query r-hash)]
    (rf/dispatch [::router/redirect-to-path-with-query-params (->route :search) (:query-params route)])))

(defn date->yyyy-mm-dd
  [date]
  (when date
    (let [m (moment date)]
      (.format m "YYYY-MM-DD"))))

(defn view
  []
  (let [selected (r/atom [])
        user @(rf/subscribe [::app-events/user])
        r-hash (roles-hash user)
        restricted? (restricted-role? user)]
    [:div
     {:class component-name}
     [:div
      {:class (bem/be component-name :nav)}
      [my-searches/view]]
     [:div
      {:class (bem/be component-name :header)}
      [:div
       {:class (bem/be component-name :search-bar)}
       [input-search
        {:placeholder @(rf/subscribe [::i18n/translate "Find..."])
         :on-change (fn [e] (rf/dispatch [::events/signal-filter (str (.-value (.-target e)))]))
         :value @(rf/subscribe [::events/signal-filter])}]]
      (when-not restricted?
        [:div
         {:class (bem/be component-name :add-new-saved-search)}
         [:button.button
          {:class (bem/bm :button [:light :medium])
           :on-click #(rf/dispatch [::modals/set-modal :my-searches.signals/edit {:data-edit nil}])}
          [icon :common :save]
          [tr "New Saved Search"]]])]
     [:div
      {:class (bem/be component-name :content)}
      [table
       {:columns (remove nil? [{:title [tr "Title"]
                                :render (fn [{:keys [signal/title] :as signal}]
                                          [:a
                                           {:on-click (partial signal-detail signal r-hash)
                                            :class (bem/be component-name :table-item-title)}
                                           title])
                                :dataIndex :signal/title
                                :sorter :default} 
                               {:title [tr "Description"]
                                :render (fn [{:keys [:signal/description]}]
                                          [:span
                                           description])
                                :dataIndex :signal/description
                                :sorter :default}
                               {:title [tr "Query"]
                                :render (fn [{:keys [_] :as signal}]
                                          [pill/readonly-pills (:query/pills (q/coerce (:query/search-query signal)))
                                           (get-in signal [:query/search-query :query/order])
                                           (get-in signal [:query/search-query :query/question])
                                           (get-in signal [:query/search-query :query/viewtype])
                                           {}])}
                               {:title [tr "Recent Activity"]
                                :render (fn [{:keys [signal/recent-activity]}]
                                          [:span (date->yyyy-mm-dd recent-activity)])
                                :dataIndex :signal/recent-activity
                                :sorter :default}
                               {:title [tr "New Items"]
                                :render (fn [{:keys [signal/new-articles]}]
                                          [:span
                                           {:class (bem/be component-name :new-items)}
                                           new-articles])
                                :dataIndex :new-articles}
                               (when-not restricted?
                                 {:title ""
                                  :render (fn [{:keys [signal/title signal/uuid] :as signal}]
                                            [:span
                                             {:class (bem/be component-name :action-buttons)}
                                             [:span
                                              {:onClick #(rf/dispatch [::modals/set-modal :my-searches.signals/edit {:data-edit signal}])}
                                              [svg :common :edit]]
                                             [:span
                                              {:onClick #(rf/dispatch [::modals/set-modal :my-searches.signals/delete-confirm {:data-delete [{:title title
                                                                                                                                              :uuid uuid}]}])}
                                              [fa-icon :trash-can]]])})])
        :dataSource (reverse (sort-by :signal/recent-activity @(rf/subscribe [::events/signals])))
        :loading? @(rf/subscribe [::events/loading?])
        :rowSelection {:type "checkbox"
                       :onChange (fn [selected-row-keys selected-rows]
                                   (reset! selected selected-rows))}
        :rowKey (fn [element] (str (hash element)))
        :pagination {:defaultPageSize 10
                     :hideOnSinglePage true}}]]
     [:div
      {:class (bem/be component-name :footer)}
      (when-not restricted?
        [:div.remove-selection
         [:button.button
          {:class (bem/bm :button [:light :medium])
           :on-click #(rf/dispatch [::modals/set-modal :my-searches.signals/delete-confirm
                                    {:data-delete (mapv (fn [e]
                                                          (let [v (js->clj e :keywordize-keys true)]
                                                            (hash-map :title (get v :signal/title)
                                                                      :uuid (get v :signal/uuid)))) @selected)}])}
          [fa-icon :trash-can]
          [tr "Delete Selection"]]])]]))
